import { call } from '@advanza/api'
import Modal from '@advanza/modal'
import { Icon } from '@advanza/ui'
import LoadingDots from '@trustoo/components/ui/LoadingDots'
import { useState } from 'react'

type Response = string | 'loading' | null

function usePartialMatchSnapshot(matchId: number) {
    const [response, setResponse] = useState<Response>(null)

    const onClick = () => {
        if (response === 'loading') {
            return
        }
        setResponse('loading')
        call('office/matches/get-partial-match-snapshot/' + matchId)
            .then(({ snapshot_json }: { snapshot_json: unknown }) => {
                setResponse(
                    snapshot_json
                        ? JSON.stringify(snapshot_json, null, 2)
                        : 'No snapshot available. Debug snapshots are only captured for new partial matches.',
                )
            })
            .catch(() => {
                setResponse('Failed to load partial match snapshot. Please try again.')
            })
    }

    const clear = () => setResponse(null)

    return {
        response,
        onClick,
        clear,
    }
}

interface PartialMatchButtonProps {
    matchId: number
}

const PartialMatchButton = ({ matchId }: PartialMatchButtonProps) => {
    const { response, onClick, clear } = usePartialMatchSnapshot(matchId)
    return (
        <div>
            <button onClick={onClick}>
                <Icon name="broken_image" />
            </button>
            <Modal open={!!response} close={clear}>
                {response === 'loading' && <LoadingDots />}
                <pre>{response}</pre>
            </Modal>
        </div>
    )
}

export default PartialMatchButton
